(function(){
    angular
        .module('appback')
        .directive('ngFirma', draw);

    draw.$inject = ['$timeout'];
    function draw($timeout){
        return {
            require: 'ngModel',
            scope: {
                ngModel: "=",
                imgloc: "=",
				onFirmaUpdate: "&",
				firmaActual: "=",
				resetFirma: "="
            },
            link: function (scope, element, attrs, ngModel) {
                var canvas = element[0];
                var ctx = canvas.getContext('2d');
                var drawing = false;
                var lastX, lastY;
                var dataURL;
				console.log("FIRMA EXISTENTE", scope.firmaActual);
                $timeout(function () {
                    // Inicialización del canvas con la imagen de fondo
                    var base_image = new Image();
                    base_image.src = scope.firmaActual;
                    base_image.onload = function(){
                        canvas.width = $(element).width();
                        var heightNuevo = (base_image.height * canvas.width) / base_image.width;
                        canvas.height = heightNuevo;
                        ctx.drawImage(base_image, 0, 0, canvas.width, canvas.height);
                    }

                    // Eventos de dibujo
                    element.bind('mousedown', startDrawing);
                    element.bind('mousemove', draw);
                    element.bind('mouseup', stopDrawing);
                    element.bind('mouseleave', stopDrawing);

                    function startDrawing(event) {
                        drawing = true;
                        [lastX, lastY] = getMousePos(canvas, event);
                    }

                    function draw(event) {
                        if (!drawing) return;
                        var [currentX, currentY] = getMousePos(canvas, event);
                        ctx.beginPath();
                        ctx.moveTo(lastX, lastY);
                        ctx.lineTo(currentX, currentY);
                        ctx.strokeStyle = "#000000";
                        ctx.lineWidth = 2;
                        ctx.stroke();
                        [lastX, lastY] = [currentX, currentY];
                        updateModel();
                    }

                    function stopDrawing() {
                        drawing = false;
                        updateModel();
                    }

                    function getMousePos(canvas, evt) {
                        var rect = canvas.getBoundingClientRect();
                        return [
                            evt.clientX - rect.left,
                            evt.clientY - rect.top
                        ];
                    }

                    function updateModel() {
                        dataURL = canvas.toDataURL();
                        ngModel.$setViewValue(dataURL);
						scope.onFirmaUpdate({nuevaFirma: dataURL});
                        scope.$apply();
                    }

                    // Validador personalizado
                    ngModel.$validators.draw = function(modelValue) {
                        return angular.isDefined(modelValue) && modelValue !== '';
                    };

					function resetCanvas() {
						ctx.clearRect(0, 0, canvas.width, canvas.height);
						ngModel.$setViewValue(null);
						scope.onFirmaUpdate({nuevaFirma: null});
					}

					scope.$watch('resetFirma', function(newValue) {
						if (newValue === true) {
							resetCanvas();
							scope.resetFirma = false; // Resetear el flag
						}
					});
                });
            }
        }
    }
})();